import { apiClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

import type { BulkUpdateScreensPayload, TenantScreen } from '../types/screen.types';

/**
 * Fetch subsidiary-specific screens with enable/disable state.
 */
export async function getSubsidiaryScreens(tenantId: string): Promise<TenantScreen[]> {
  return apiClient.get(endpoints.screens.subsidiary(tenantId)).json<TenantScreen[]>();
}

/**
 * Toggle a single screen's visibility for a subsidiary.
 */
export async function toggleSubsidiaryScreen(
  tenantId: string,
  screenId: string,
): Promise<TenantScreen> {
  return apiClient
    .patch(endpoints.screens.subsidiaryToggle(tenantId, screenId))
    .json<TenantScreen>();
}

/**
 * Bulk update screen visibility/sort order for a subsidiary.
 */
export async function bulkUpdateSubsidiaryScreens(
  tenantId: string,
  payload: BulkUpdateScreensPayload,
): Promise<unknown> {
  return apiClient.post(endpoints.screens.subsidiaryBulkUpdate(tenantId), { json: payload }).json();
}

/**
 * Remove a screen assignment from a subsidiary.
 */
export async function deleteSubsidiaryScreen(tenantId: string, screenId: string): Promise<void> {
  await apiClient.delete(endpoints.screens.subsidiaryDelete(tenantId, screenId));
}
